/**
 * Shared item processor for filter panels that use display_name_group (e.g. Gender, Ethnicity).
 * Normalizes display_name and collapses grouped items to a single representative.
 */
export function processDisplayNameGroupItems(items) {
    if (!items || !items.length) return []
    const filtered = []
    items.forEach(itm => {
        if (!itm.display_name_group) {
            itm.display_name = itm.display_name || itm.value
            filtered.push(itm)
        } else {
            const o = items.find(x => x.value === itm.display_name_group[0])
            if (o && !filtered.find(x => x.display_name === o.display_name)) {
                filtered.push({
                    ...o,
                    display_name: o.display_name || o.value,
                })
            }
        }
    })
    return filtered
}
